export default __webpack_public_path__ + "static/media/lienquiry-submitted-icon.0ea98ad3.svg";